import { useTranslation } from 'react-i18next';
import { FinecoAgentIcon } from 'shared/assets/svg/FinecoAgentIcon';
import colorsStore from 'shared/store/colorsStore';

export const ChatLoading: React.FC = () => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);

  const { t } = useTranslation();
  const iconSizeClass = `icon-size-32-32`;
  return (
    <>
      <div className="flex-grow">
        <div className="grid h-full place-items-center">
          <div className="text-center">
            <div className="animated-div mb-4 flex items-center justify-center gap-4">
              <FinecoAgentIcon className={iconSizeClass} />
              <h1
                style={{
                  color: colorsConfig.chatCopyColor,
                  fontSize: 24,
                  marginTop: 5,
                }}
              >
                {t('assistant.connecting')}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
